import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration'
import CourseSection from '../CourseSection/CourseSection'
import './CourseSeason.css'
export default function CourseSeason({season,isBuyer}) {
  const [sectionData,setSectionData] = useState([])
  useEffect(()=>{
    axiosConfig.get('api/Courses/' + season.id + '/part').then((res)=>{
      setSectionData(res.data)
    })
  },[])
  return (
    <div className='course-season'>
        <div className='course-Season-topic'>
           <h1>{season.title}</h1>
           {/* <span>100 دقیقه</span> */}
        </div>
        <div className='course-sections'>
           {
            sectionData.map((section,index)=>(
              <CourseSection isBuyer={isBuyer} key={index} section={section}/>
            ))
           }
        </div>
    </div>
  )
}
